import { Box, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { badgeHeadCells } from './BadgeTableHeadCells';
import { visuallyHidden } from '@mui/utils';
import { GroupAdd, Preview } from "@mui/icons-material";

export default function BadgeTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead sx={{ backgroundColor: "#cdd1dc" }}>
            <TableRow>
                {badgeHeadCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        //padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {
                            headCell.sortable ?
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={createSortHandler(headCell.id)}
                                >
                                    {headCell.label}
                                    {orderBy === headCell.id ? (
                                        <Box component="span" sx={visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    ) : null}
                                </TableSortLabel>
                                : <TableSortLabel hideSortIcon>
                                    {headCell.id === "preview" ? <Preview sx={{ paddingRight: "3px" }} /> : null}
                                    {headCell.id === "recipients" ? <GroupAdd sx={{ paddingRight: "3px" }} /> : null}
                                    {headCell.label}
                                </TableSortLabel>
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}